import { render, staticRenderFns } from "./JobOrders.vue?vue&type=template&id=97d3adec&"
import script from "./JobOrders.vue?vue&type=script&lang=js&"
export * from "./JobOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports